module.exports = __webpack_public_path__ + "img/etsy-inactive.cd5047b.png";